var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconPaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15h5v1H4v-1zm8-1H4v-1h8v1zm1.5 4h-11c-.3 0-.5-.2-.5-.5V11h12.8c1.2-1.2 2.8-2 4.7-2 .9 0 1.7.2 2.5.5V6c0-1.1-.9-2-2-2H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h12.8c-.5-.6-1-1.3-1.3-2zM2 6.5c0-.3.2-.5.5-.5h17c.3 0 .5.2.5.5V8H2V6.5z",
    fill: "#727582"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20c2.5 0 4.5-2 4.5-4.5S22 11 19.5 11 15 13 15 15.5s2 4.5 4.5 4.5zm-.5-2.5l-1.7-1.6.7-.7 1 .9 2.1-2.2.7.7-2.8 2.9z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1538e5"
  })));
}

export default SvgIconPaid;